export const ALGOLIA_APP_ID = process.env.NEXT_PUBLIC_ALGOLIA_APPLICATION_ID;
export const ALGOLIA_APP_KEY = process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY;
export const ALGOLIA_INDEX_NAME = process.env.NEXT_PUBLIC_ALGOLIA_INDEX_NAME || '';
// TODO: Change after devops creates the environment env.
// because it is possible to see it in the requests, so there is no problem with it being inserted in the code
export const ALGOLIA_INDEX_NAME_QUERY_SUGGESTIONS = 'prod_sympla_events_query_suggestions';
export const ALGOLIA_INITIAL_SEARCH = 'starting value of algolia search';
export enum AlgoliaFilterAttributes {
  IS_ACCESSIBLE_FOR_FREE = 'is_accessible_for_free',
  TYPE = 'type',
}

export const ALGOLIA_NUMBER_CARACTER = 2;
